import { fetchWithAuth } from "./utils/ApiUtils";
import { config } from "./Constants";

const URL = config.url;
const BASE_URL = `${URL}/api/v1/user-state-preferences`;

export const StatePreferenceService = {
    getUserStatePreferences: async () => {
        try {
            const response = await fetchWithAuth(BASE_URL);
            if (!response.ok) {
                throw new Error('Failed to fetch state preferences');
            }
            const data = await response.json();
            return data.data || [];
        } catch (error) {
            console.error('Error fetching state preferences:', error);
            throw error;
        }
    },

    getAllAvailableStates: async () => {
        try {
            const response = await fetchWithAuth(`${BASE_URL}/states`);
            if (!response.ok) {
                throw new Error('Failed to fetch available states');
            }
            const data = await response.json();
            return data.data || [];
        } catch (error) {
            console.error('Error fetching available states:', error);
            throw error;
        }
    },

    updateUserStatePreferences: async (stateIds) => {
        try {
            const response = await fetchWithAuth(BASE_URL, {
                method: 'PUT',
                body: JSON.stringify(stateIds)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to update state preferences');
            }

            const data = await response.json();
            return data.data;
        } catch (error) {
            console.error('Error updating state preferences:', error);
            throw error;
        }
    },

    addStatePreference: async (stateId) => {
        try {
            const response = await fetchWithAuth(`${BASE_URL}/${stateId}`, {
                method: 'POST'
            });

            if (!response.ok) {
                throw new Error('Failed to add state preference');
            }

            return true;
        } catch (error) {
            console.error('Error adding state preference:', error);
            throw error;
        }
    },

    removeStatePreference: async (stateId) => {
        try {
            const response = await fetchWithAuth(`${BASE_URL}/${stateId}`, {
                method: 'DELETE'
            });

            if (!response.ok) {
                throw new Error('Failed to remove state preference');
            }

            return true;
        } catch (error) {
            console.error('Error removing state preference:', error);
            throw error;
        }
    },

    getStatePreferenceCount: async () => {
        try {
            const response = await fetchWithAuth(`${BASE_URL}/count`);
            if (!response.ok) {
                throw new Error('Failed to get state preference count');
            }
            const data = await response.json();
            return data.data || 0;
        } catch (error) {
            console.error('Error getting state preference count:', error);
            return 0;
        }
    }
};